import PeerVideo from "./peerVideo";
import PeerVideosContent from "./peerVideosContent";

const OtherPeerVideos = ({remoteStreams, switchVideo, roomKey}) => {

    return ( 
        <div className="remote-videos-display">
            {remoteStreams && remoteStreams.map((vid, index)=>(
                <div 
                className="other-peers-video"
                onClick={() => switchVideo(vid.stream, vid.userName, vid.loc)}
                style={{display: "inline-block"}}
                key={index}
                >
                    <PeerVideo  videoStream={vid.stream} mute={false}/>
                    <h4 className="other-peers-video-name">{`${vid.userName}(${vid.loc})`}</h4>
                    <PeerVideosContent 
                        peerName={vid.userName}
                        peerid={vid.peerID}
                        roomKey={roomKey}
                    />
                </div>
            ))}
        </div>
     );
}
export default OtherPeerVideos;